module.exports = __webpack_public_path__ + "img/sx1.91651351.png";